// Plugins
import "core-js/stable";
import "regenerator-runtime/runtime";
import "picturefill";
import _, { map } from "underscore";
import $ from "jquery";
import "slick-carousel";
import "@selectize/selectize";
// Fletcher modules
import Enquire from "enquire.js";
// import Loader from 'app/Loader';
import StaticMap from "./app/StaticMap";
import Video from "./app/new/Video";
// import FilterGrid from "./app/new/FilterGrid";
import SiteCarousel from "./app/new/SiteCarousel";
import { Navigation, StickyNavigation } from "./app/Navigation";
import Forms from "./app/Forms";
import ShowhomeForm from "./app/new/ShowhomeForm";
import DevelopmentsNav from "./app/new/DevelopmentsNav";
import Floorplan from "./app/components/Floorplan";
import Explorer from "./app/components/Explorer";
import ScrollSpy from "./app/new/ScrollSpy";
import Gallery from "./app/components/Gallery";
import Tabs from "./app/components/Tabs";
import Cleave from "cleave.js";
import Foundation from "foundation-sites";
import Swiper from "swiper";
import { HolidayMessage } from "./app/components/HolidayMessage";
import { HomePageSearch } from "./app/components/HomePageSearch";
import { AccordionImageItems } from "./app/components/AccordionImageItems";
import { HomeBannerSwiper } from "./app/components/HomeBannerSwiper";

// 'use strict';
$(() => {
  //$(document).foundation();
  $(".accordion").foundation(); // NOTE: Do this individually, custom scripts like sticky nav have issues with global foundation initialisation

  // FastClick.attach(document.body); // Removed since Safari 9.1 and up has removed 300ms tap if device-width and user-scalable=no is set

  // Initialised before the forms script
  $("select:not(.custom-select, .pop-up)").selectize({
    allowEmptyOption: true,
    onInitialize: function () {
      this.$control_input.attr("readonly", true);
    },
  });

  // disable input for showhome form
  $(
    ".showhome .selectize-control.single .selectize-input, .showhome  .selectize-control.single .selectize-input input",
  ).attr("readonly", true);

  /*

    Foundation breakpoints :
    -----------------------

    $breakpoints: (
    small   : 0,
    medium  : 640px,
    xmedium : 768px,
    large   : 1024px,
    xlarge  : 1100px,
    xxlarge : 1440px
    );
    */
  let video = new Video();

  function replaceBackgroundImage(media) {
    _.each($("[data-bg]"), (image) => {
      let url = $(image).data(media);
      $(image).css("background-image", `url("${url}")`);
    });
  }

  Enquire.register("screen and (max-width:640px)", {
    match: function () {
      replaceBackgroundImage("bg-small");
    },
  });

  Enquire.register("screen and (min-width:1024px)", {
    match: function () {
      replaceBackgroundImage("bg-large");
    },
  });

  Enquire.register("screen and (min-width:640px) and (max-width: 1024px)", {
    match: function () {
      replaceBackgroundImage("bg-large");
    },
  });

  // Load map or grid, based on body having data-mode = map or grid
  if ($("body").hasClass("city-container")) {
    // let loader = new Loader;
    // loader.load($('body').data('mode'));
  }

  // Load static maps
  if ($("#map-house").length > 0) {
    let map = new StaticMap();
    map.load($("#map-house"));
  }

  // Save PDF data based on floorplan, for reference based on index
  var floorPlanPDFs = [];
  $(".floorplan").each(function (index, item) {
    floorPlanPDFs.push($(item).data("pdf"));
  });

  var $floorplan = $(".floorplans").one();
  ("log");
  var $floorplansCarousel = $floorplan
    .find(".floorplans__carousel--many-slides")
    .slick({
      speed: 1200,
      useCSS: true,
      useTransform: true,
      vertical: true,
      verticalSwiping: true,
      cssEase: "cubic-bezier(0.190, 1.000, 0.220, 1.000)",
      // prevArrow: '.floorplans__prev-btn',
      // nextArrow: '.floorplans__next-btn'
      prevArrow: $floorplan.find(".js-prev"),
      nextArrow: $floorplan.find(".js-next"),
    });

  $floorplansCarousel.on("afterChange", function (e, slick, currentSlide) {
    // update the download button using current slide index to find PDF URL
    $(".floorplans__download-btn")
      .attr(
        "title",
        !floorPlanPDFs[currentSlide] ? "no PDF available" : "view PDF",
      )
      .attr("href", floorPlanPDFs[currentSlide]);
  });

  $(".holiday-message").addClass("holiday-message--ready");

  $(".site-carousel").each(function (key, el) {
    new SiteCarousel(el);
  });

//   new FilterGrid();
  new Forms();
  new ShowhomeForm();
  new Navigation(new StickyNavigation());
  new DevelopmentsNav();

  // Initialize all Apartment Floorplan Explorers
  const explorers = document.querySelectorAll(".c-explorer");
  Array.from(explorers).map((explorer) => {
    new Explorer(explorer);
  });

  new ScrollSpy({
    list: document.getElementById("js-scrollspy"),
  });

  new Gallery({
    elements: document.querySelectorAll("*[data-gallery-item]"),
  });

  new Tabs();

  // Register your interest form only
  let budgetFrom = document.querySelector('input[name="budgetfrom"]');
  let budgetTo = document.querySelector('input[name="budgetto"]');
  if (budgetFrom) {
    var cleave = new Cleave(budgetFrom, {
      prefix: "$",
      numeral: true,
      numeralThousandsGroupStyle: "thousand",
      noImmediatePrefix: true,
    });
  }
  if (budgetTo) {
    var cleave = new Cleave(budgetTo, {
      prefix: "$",
      numeral: true,
      numeralThousandsGroupStyle: "thousand",
      noImmediatePrefix: true,
    });
  }

  // Cloud amp tracking
  if (document.getElementById("cloudamp__data__c")) {
    window._cloudAmp = window._cloudAmp || {};
    _cloudAmp.forms = [];
    (function () {
      var scripts = document.getElementsByTagName("script"),
        sLen = scripts.length,
        ca_script = document.createElement("script"),
        head = document.getElementsByTagName("head"),
        protocol = document.location.protocol,
        httpsDomain =
          "1d5ef9e9369608f625a8-878b10192d4a956595449977ade9187d.ssl.cf2.rackcdn.com",
        httpDomain = "trk.cloudamp.net",
        filename = "ctk.js",
        srcDomain = protocol === "http:" ? httpDomain : httpsDomain;

      ca_script.type = "text/javascript";
      ca_script.async = true;
      ca_script.src = protocol + "//" + srcDomain + "/" + filename;
      head[0].appendChild(ca_script);
    })();
  }

  // Showhomes pages
  if ($(".showhome-content-block").length > 0) {
    function HideContent() {
      var RightColHeight = 0;

      // Get height of right column
      $(".showcase-home-details")
        .first()
        .children()
        .filter(":visible")
        .each(function () {
          RightColHeight += $(this).outerHeight();
        });

      RightColHeight < 250
        ? (RightColHeight = 250)
        : (RightColHeight = RightColHeight); // 250 minimum height

      // If content taller than right column value
      if ($(".showhome-content-block").first().height() > RightColHeight) {
        var ContentHeight = RightColHeight - 65; // 65px for height of bottom margins and READ MORE link
        $(".content-inner").height(ContentHeight);
        $(".content-inner").addClass("fade");
        $(".read-more-cta").show();
        $(".read-more-cta").click(function (event) {
          event.preventDefault();
          event.stopPropagation();
          if ($(this).hasClass("open")) {
            $(".content-inner").addClass("fade");
            $(".content-inner").removeClass("open");
            $(".content-inner").height(ContentHeight);
            $(this).removeClass("open");
            $(".read-more-cta").html("READ MORE");
          } else {
            $(".content-inner").removeClass("fade");
            $(".content-inner").addClass("open");
            $(".content-inner").height("auto");
            $(this).addClass("open");
            $(".read-more-cta").html("SHOW LESS");
          }
        });
      }
      // Content is shorter
      else {
        $(".content-inner").height("auto");
        $(".read-more-cta").hide();
      }
    }

    HideContent();
  }

  //Swiper.use([Navigation, Pagination])

  var HomeSwiper = new Swiper(".home-swiper", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 6000,
    },
    keyboard: {
      enabled: true,
    },
  });

  // Speak to us swiper //
  var swiperSpeak = new Swiper(".speak-to-us-swiper", {
    navigation: {
      nextEl: ".swiper-button-next-new",
      prevEl: ".swiper-button-prev-new",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    lazy: true,
  });

  var testimonialSwiper = new Swiper(".testimonialSwiper", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  var videoTestimonialSwiper = new Swiper(".videoTestimonialSwiper", {
    slidesPerView: "auto",
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var featuredArticleSwiper = new Swiper(".featuredArticleSwiper", {
    slidesPerView: 1,
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Find floor plan siper titles inject them into pagnation below //
  var titles = [],
    els = document.querySelectorAll(".floor-plan-swiper .swiper-slide"),
    i = 0;

  for (i = 0; i < els.length; i++) {
    if (els[i]) {
      titles.push(els[i].dataset.title);
    }
  }

  var swiperFloor = new Swiper(".floor-plan-swiper", {
    pagination: {
      el: ".floor-plan-swiper .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return (
          '<span class="' +
          className +
          '">' +
          "<span>" +
          titles[index] +
          "</span>" +
          "</span>"
        );
      },
    },
    lazy: true,
  });

  var swiperAmenities = new Swiper(".amenities-swiper--container", {
    slidesPerView: "auto",
    centeredSlides: false,
    spaceBetween: 30,
    grabCursor: true,
    lazy: {
      elementClass: "swiper-lazy",
      loadPrevNext: true,
      loadPrevNextAmount: 3,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1024: {
        spaceBetween: 60,
        centeredSlides: false,
      },
    },
  });

  const overlayTriggers = document.querySelectorAll(".js-open-overlay");
  const overlayHouse = document.getElementById("overlay-house");
  const close = document.getElementById("js-close-modal");
  const modalWrap = document.querySelector(".js-modal");
  const app = document.getElementById("app");

  if (overlayTriggers.length) {
    for (var i = 0; i < overlayTriggers.length; i++) {
      overlayTriggers[i].addEventListener("click", function (e) {
        e.stopPropagation();
        if (overlayHouse) {
          overlayHouse.classList.add("show");
          // add class to body to prevent scrolling
          document.body.classList.add("overflow-hidden");
        } else {
          console.error("overlay popup video element not found!");
        }

        stopVideos();
        // Add swiper events
        var galleryThumbs = new Swiper(".gallery-thumbs", {
          spaceBetween: 10,
          slidesPerView: 10,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          lazy: true,
        });

        /* not to use on the homepage, as it has conflict with homepage banner */

        if (!document.querySelector(".section-home-banner")) {
          // pop up swiper
          var swiperHouse = new Swiper(".house-swiper", {
            spaceBetween: 20,
            pagination: {
              el: ".house-swiper .swiper-pagination",
              type: "bullets",
              clickable: true,
            },
            on: {
              slideChange: function (el) {
                stopVideos();
              },
            },
            lazy: true,
            thumbs: {
              swiper: galleryThumbs,
            },
            breakpoints: {
              1024: {
                spaceBetween: 40,
                pagination: {
                  el: ".house-swiper .swiper-pagination",
                  type: "fraction",
                  clickable: false,
                  renderFraction: function (currentClass, totalClass) {
                    return (
                      '<span class="' +
                      currentClass +
                      '"></span>' +
                      " <span> / </span> " +
                      '<span class="' +
                      totalClass +
                      '"></span>' +
                      " <span> Photos </span> "
                    );
                  },
                },
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              },
            },
          });

          const scrollY =
            document.documentElement.style.getPropertyValue("--scroll-y");
          app.style.position = "fixed";
          app.style.width = "100%";
          app.style.top = `-${scrollY}`;
          const slideNumber = this.getAttribute("data-position");

          swiperHouse.slideTo(slideNumber);
        }
      });
    }

    // Initiate mobile swiper
    if (window.innerWidth < 1024) {
      var swiperHeroMobile = new Swiper(".mobile-hero-swiper", {
        pagination: {
          el: ".mobile-hero-swiper .swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        lazy: true,
      });
    }

    close.addEventListener("click", function () {
      overlayHouse.classList.remove("show");
      // remove class to body to prevent scrolling
      if (document.body.classList.contains("overflow-hidden")) {
        document.body.classList.remove("overflow-hidden");
      }

      const scrollY = app.style.top;
      app.style.position = "";
      app.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);

      stopVideos();
    });

    //Closes the modal when the document is clicked
    overlayHouse.addEventListener("click", () => {
      overlayHouse.classList.remove("show");
      if (document.body.classList.contains("overflow-hidden")) {
        document.body.classList.remove("overflow-hidden");
      }

      const scrollY = app.style.top;
      app.style.position = "";
      app.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
      stopVideos();
    });

    //Prevents the click event from reaching the document
    app.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    modalWrap.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    window.addEventListener("scroll", () => {
      document.documentElement.style.setProperty(
        "--scroll-y",
        `${window.scrollY}px`,
      );
    });
  }

  // stop video on swiper change //
  var stopVideos = function () {
    playPauseVideo();
    $("#house-video").each(function (e) {
      $(this).attr("src", $(this).attr("src"));
    });
  };

  var playPauseVideo = function () {
    var videobanner = document.querySelector("#video-banner");
    if (videobanner) {
      if (videobanner.paused === true) {
        videobanner.play();
      } else {
        videobanner.pause();
      }
    }
  };

  // Handle scroll on the sub navs not in vue
  if ($(".house-top-nav")) {
    var oldScrollPos = window.pageYOffset,
      scrollSensitivity = 2;

    $(window).scroll(function () {
      if (
        Foundation.MediaQuery.is("small only") ||
        Foundation.MediaQuery.is("medium only")
      ) {
        if (window.pageYOffset >= oldScrollPos && window.pageYOffset > 300) {
          if (window.pageYOffset - oldScrollPos > scrollSensitivity) {
            $(".house-top-nav").fadeOut(100);
          }
        } else if (oldScrollPos > window.pageYOffset) {
          if (oldScrollPos - window.pageYOffset > scrollSensitivity) {
            $(".house-top-nav").fadeIn(100);
          }
        }
        oldScrollPos = window.pageYOffset;
      } else {
        $(".house-top-nav").fadeIn(100);
      }
    });
  }

  // Masonary image calculate height dynamically
  let elementMasonryImage = document.querySelector(
    ".o-element--masonry__images",
  );
  const elementMasonryContent = document.querySelector(
    ".o-element--masonry__content",
  );

  if (elementMasonryImage && elementMasonryContent) {
    if (window.matchMedia("(min-width: 768px)").matches) {
      let elementMasonryImageHeight =
        elementMasonryImage.getBoundingClientRect().width +
        elementMasonryImage.getBoundingClientRect().width * 0.1;
      // compare the height of the image and the content
      if (
        elementMasonryImageHeight <
        elementMasonryContent.getBoundingClientRect().height
      ) {
        elementMasonryImage.style.height = elementMasonryImageHeight + "px";
      }

      window.addEventListener("resize", function (event) {
        let elementMasonryImageHeight =
          elementMasonryImage.getBoundingClientRect().width +
          elementMasonryImage.getBoundingClientRect().width * 0.1;
        //elementMasonryImage.parentElement.style.height = elementMasonryImageHeight + "px";
      });
    } else {
      //elementMasonryImage.parentElement.style.height = "auto";
    }
  }

  // Sticky bottom nav
  let stickyBottomNav = document.querySelector(".sticky-bottomNav");

  if (stickyBottomNav) {
    let scrolly, breakpoint;

    breakpoint =
      $(stickyBottomNav).parent().offset().top -
      $(stickyBottomNav).data("offset"); // Is already pinned

    if (window.pageYOffset > breakpoint || elementInViewport(stickyBottomNav)) {
      scrolly = breakpoint;
      stickyBottomNav.classList.add("stickToBottom");
    }

    window.addEventListener("scroll", function () {
      if (scrolly >= window.pageYOffset) {
        stickyBottomNav.classList.remove("stickToBottom");
      }

      if (
        elementInViewport(stickyBottomNav) &&
        !stickyBottomNav.classList.contains("stickToBottom")
      ) {
        scrolly = window.pageYOffset;
        stickyBottomNav.classList.add("stickToBottom");
      }
    });

    // If sticky bottom nav exists, add padding-bottom to footer
    document.querySelector("footer").style.paddingBottom =
      stickyBottomNav.getBoundingClientRect().height + 30 + "px";
  }

  function elementInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  let developmentOverviewMapObject = document.querySelector(
      "#development-overview-map-object",
    ),
    panZoomMap;

  let mapLoading = document.querySelector("#overview-map-loading");
  if (developmentOverviewMapObject) {
    // window.onload = function() {
    var eventsHandler;

    eventsHandler = {
      haltEventListeners: [
        "touchstart",
        "touchend",
        "touchmove",
        "touchleave",
        "touchcancel",
      ],
      init: function (options) {
        var instance = options.instance,
          initialScale = 1,
          pannedX = 0,
          pannedY = 0;

        // Init Hammer
        // Listen only for pointer and touch events
        this.hammer = Hammer(options.svgElement, {
          inputClass: Hammer.SUPPORT_POINTER_EVENTS
            ? Hammer.PointerEventInput
            : Hammer.TouchInput,
        });

        // Enable pinch
        this.hammer.get("pinch").set({ enable: true });

        // Handle double tap
        this.hammer.on("doubletap", function (ev) {
          instance.zoomIn();
        });

        // Handle pan
        this.hammer.on("panstart panmove", function (ev) {
          // On pan start reset panned variables
          if (ev.type === "panstart") {
            pannedX = 0;
            pannedY = 0;
          }

          // Pan only the difference
          instance.panBy({
            x: ev.deltaX - pannedX,
            y: ev.deltaY - pannedY,
          });
          pannedX = ev.deltaX;
          pannedY = ev.deltaY;
        });

        // Handle pinch
        this.hammer.on("pinchstart pinchmove", function (ev) {
          // On pinch start remember initial zoom
          if (ev.type === "pinchstart") {
            initialScale = instance.getZoom();
            instance.zoomAtPoint(initialScale * ev.scale, {
              x: ev.center.x,
              y: ev.center.y,
            });
          }

          instance.zoomAtPoint(initialScale * ev.scale, {
            x: ev.center.x,
            y: ev.center.y,
          });
        });

        // Prevent moving the page on some devices when panning over SVG
        options.svgElement.addEventListener("touchmove", function (e) {
          e.preventDefault();
        });
      },

      destroy: function () {
        this.hammer.destroy();
      },
    };

    //  developmentOverviewMapObject.addEventListener('load', function () {
    var interva = setInterval(function () {
      developmentOverviewMapObject.contentDocument
        .querySelector("svg")
        .setAttribute("width", "1334");
      developmentOverviewMapObject.contentDocument
        .querySelector("svg")
        .setAttribute("height", "760");
      // Will get called after embed element was loaded
      // mouse scroll enabled for tablet and removed for desktop
      if (window.matchMedia("(min-width: 1025px)").matches) {
        panZoomMap = svgPanZoom(developmentOverviewMapObject, {
          zoomEnabled: false,
          controlIconsEnabled: true,
          fit: true,
          center: true,
          maxZoom: 225,
          zoomScaleSensitivity: 0.2,
        });
      } else {
        panZoomMap = svgPanZoom(developmentOverviewMapObject, {
          zoomEnabled: true,
          controlIconsEnabled: true,
          fit: true,
          center: true,
          maxZoom: 225,
          zoomScaleSensitivity: 0.2,
          customEventsHandler: eventsHandler,
        });
      }

      // Re-center the map so that the current value is in the middle
      $(".content-container .content").hover(function (e) {
        var elementID = $(this).attr("data-id"),
          splitElmIDs = elementID.split(",");
        if (splitElmIDs.length > 0) {
          panZoomMap.center();

          var mapElmX = 0,
            mapElmY = 0,
            mapElmWidth = 0,
            mapElmHeight = 0;
          // grab each matching flag and add to total
          for (var i = 0; i < splitElmIDs.length; i++) {
            var mapElm = developmentOverviewMapObject.contentDocument
              .querySelector("#" + splitElmIDs[i])
              .getBBox();
            mapElmX = mapElmX + mapElm.x;
            mapElmY = mapElmY + mapElm.y;
            mapElmWidth = mapElmWidth + mapElm.width;
            mapElmHeight = mapElmHeight + mapElm.height;
          }

          mapElmX = mapElmX / splitElmIDs.length;
          mapElmY = mapElmY / splitElmIDs.length;
          mapElmWidth = mapElmWidth / splitElmIDs.length;
          mapElmHeight = mapElmHeight / splitElmIDs.length;

          var viewBox = panZoomMap.getSizes().viewBox;
          var realZoom = panZoomMap.getSizes().realZoom;
          var x = viewBox.width / 2 - mapElmX - mapElmWidth / 2;
          var y = viewBox.height / 2 - mapElmY - mapElmHeight / 2;

          panZoomMap.panBy({
            x: x * realZoom,
            y: y * realZoom,
          });
        }
      });

      var baseZoom = 85;
      if ($("#base-map-zoom")) {
        baseZoom = $("#base-map-zoom").attr("zoom");
      }
      panZoomMap.zoomAtPointBy(baseZoom, {
        x: developmentOverviewMapObject.getBoundingClientRect().width / 2,
        y: developmentOverviewMapObject.getBoundingClientRect().height / 2,
      });
      if (mapLoading) {
        // hide the mapLoading div once the map is loaded
        mapLoading.classList.add("hidden");
      }
      // show the map if it is loaded
      developmentOverviewMapObject.classList.remove("hidden");

      clearInterval(interva);
    }, 1000);
    //});
  }

  // On click function to takes value in the input on button click having class search-button
  var searchButton = document.querySelectorAll(".search-button");
  if (searchButton.length > 0) {
    HomePageSearch.init();
  }
  // end of search homes function

  if (document.getElementById("holiday-message")) {
    HolidayMessage.init();
  }
});

function showImages(el) {
  var windowHeight = jQuery(window).height();
  $(el).each(function () {
    var thisPos = $(this).offset().top;

    var topOfWindow = $(window).scrollTop();
    if (topOfWindow + windowHeight - 200 > thisPos) {
      $(this).addClass("fadeIn");
      if (
        this.parentElement.parentElement.parentElement.hasAttribute(
          "data-moveLeft",
        )
      ) {
        $(this.parentElement.parentElement.parentElement).addClass("moveLeft");
      }
    }
  });
}

// Wait for window load
$(window).on("load", function () {
  // Animate loader off screen
  $(".se-pre-con").fadeOut("slow");
  showImages("[data-fadein]");

  // Speak to us swiper //

  // if element class name featured-location-swiper exists, then initiate the swiper
  if (document.querySelector(".featured-location-swiper")) {
    const swiper = new Swiper(".featured-location-swiper", {
      slidesPerView: 1.05,
      spaceBetween: 16,
      watchSlidesVisibility: true,
      slideFullyVisibleClass: "swiper-slide-fully-visible", // not support in the current version?
    });
  }

  var swiperList = new Swiper(".development-list-swiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    lazy: true,
  });

  // Tabs
  const sectionTabs = document.querySelector(".section-tabs");
  if (sectionTabs) {
    let apartmentSwiper;

    function TabsNavigation() {
      var bindAll = function () {
        var menuElements = document.querySelectorAll("[data-tab]");
        // Setting first tab as active
        var id = menuElements[0].getAttribute("data-tab");
        document.getElementById(id).classList.add("active");

        for (var i = 0; i < menuElements.length; i++) {
          menuElements[i].addEventListener("click", change, false);
        }
      };

      var clear = function () {
        var menuElements = document.querySelectorAll("[data-tab]");

        for (var i = 0; i < menuElements.length; i++) {
          menuElements[i].querySelectorAll("span").forEach((item) => {
            item.classList.remove("active");
          });
          var id = menuElements[i].getAttribute("data-tab");
          document.getElementById(id).classList.remove("active");
        }
      };

      var change = function (e) {
        clear();
        e.target.classList.add("active");
        var id = e.currentTarget.getAttribute("data-tab");
        document.getElementById(id).classList.add("active");
        if (apartmentSwiper) {
          apartmentSwiper.forEach((swiper) => {
            swiper.update();
          });
        }
      };

      bindAll();
    }

    TabsNavigation();

    apartmentSwiper = new Swiper(".apartmentType-swiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      spaceBetween: 20,

      breakpoints: {
        // when window width is >= 768px
        768: {
          spaceBetween: 0,
        },
      },

      lazy: true,
    });
  }
  if (document.querySelectorAll("[data-accordion-item]").length > 0) {
    AccordionImageItems.init();
  }
});

// if the image in the window of browser when scrolling the page, show that image
$(window).scroll(function () {
  showImages("[data-fadein]");
});

const homeBanner = document.querySelector(".section-home-banner");
const bannerCarousel = document.querySelector(".section-banner-carousel");
const siteHeader = document.querySelector(".site-header");
const navBar = document.querySelector(".navbar");
const navBarLinks = document.querySelectorAll(".link");
const searchPanel = document.querySelector(".search-box--desktop");

if (homeBanner || bannerCarousel) {
  // only run the below code if the .home-swiper exists
  if (document.querySelector(".home-swiper")) {
    HomeBannerSwiper.init();
  }

  if (homeBanner) {
    if (siteHeader && navBar) {
      siteHeader.classList.add("home");
      navBar.classList.add("home");

      for (var i = 0; i < navBarLinks.length; i++) {
        navBarLinks[i].querySelectorAll(".level1__link").forEach((item) => {
          item.classList.add("home");
        });
      }
      var className = "home";
      var scrollTrigger = 200;

      window.onscroll = function () {
        // We add pageYOffset for compatibility with IE.
        if (
          window.scrollY >= scrollTrigger ||
          window.pageYOffset >= scrollTrigger
        ) {
          document.querySelector(".navbar").classList.remove(className);
          var navBarLinks = document.querySelectorAll(".link");
          for (var i = 0; i < navBarLinks.length; i++) {
            navBarLinks[i].querySelectorAll(".level1__link").forEach((item) => {
              item.classList.remove("home");
            });
          }
        } else {
          // document.querySelector(".site-header").classList.add(className);
          document.querySelector(".navbar").classList.add(className);
          var navBarLinks = document.querySelectorAll(".link");
          for (var i = 0; i < navBarLinks.length; i++) {
            navBarLinks[i].querySelectorAll(".level1__link").forEach((item) => {
              item.classList.add("home");
            });
          }
        }
      };
    }
  }

  /*

    handle banner max height if searchPanel exist

    */
  // if (searchPanel) {
  //     homeBanner.style.maxHeight = `calc(100dvh - ${(
  //         searchPanel.clientHeight / 2
  //     ).toString()}px)`;
  // }
}

// show/hide navbar on scroll up & down
var lastScrollTop = 0;
$(window).scroll(function () {
  var st = $(this).scrollTop();
  var navBars = $(".stuck"); // all other sticky nav bar
  var siteHeader = $(".navbar"); // top navbar
  let navbarHeight =
    siteHeader.outerHeight() > 30 ? siteHeader.outerHeight() : 76;

  setTimeout(function () {
    // Main sticky navigation
    if (st > lastScrollTop && lastScrollTop > 100) {
      siteHeader.addClass("hide-navbar");
    } else {
      siteHeader.removeClass("hide-navbar");
    }

    // Sticky nav bars
    if (st > lastScrollTop && navBars && lastScrollTop > 100) {
      navBars.each(function () {
        $(this).css("top", $(this).data("offset"));
      });
      // navBars.addClass('hide-navbar');
    } else {
      navBars.each(function () {
        $(this).css("top", $(this).data("offset") + navbarHeight);
      });
      // navBars.removeClass('hide-navbar');
    }
    lastScrollTop = st;
  }, 100);
});

var timeout=setTimeout(() => {
    // console.log("page data", Evergage.getState().result.currentPage);
    Evergage.init().then(() => {
    const state = Evergage.getState();
    if (state && state.result && state.result.currentPage && state.result.currentPage.user) {
        const anonId = state.result.currentPage.user.anonId;
        // console.log("anonId",anonId);  // This should now have the value you want
    } else {
        console.error("User information is not yet available.");
    }
});
    clearTimeout(timeout);
}, 2000);
